import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=69f16454"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f16454')) {
      api.createRecord('69f16454', component.options)
    } else {
      api.reload('69f16454', component.options)
    }
    module.hot.accept("./TaskDetail.vue?vue&type=template&id=69f16454", function () {
      api.rerender('69f16454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Task/TaskDetail.vue"
export default component.exports